import styled from 'styled-components';
import colors from '../../assets/styles/colors';

export const TermsOfServiceContainer = styled.main`
  height: 100%;
  display: grid;
  grid-template-columns: minmax(720px, 40%) 1fr;
  overflow: hidden;
  background: ${colors.white};

  button:disabled {
    background: ${colors.grayLight};
    border: 1px solid ${colors.grayLight};
    color: ${colors.white};
  }
`;

export const TermsOfServiceColumn = styled.div`
  height: 100%;

  &:last-child {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
`;

export const TermsOfServiceTitle = styled.h3`
  color: ${colors.textPrimary};
  font-weight: bold;
  font-size: 14px;
  line-height: 17px;
`;

export const TermsOfServiceContent = styled.div`
  margin-top: 60px;
  background: ${colors.textExGrayLight};
  border-radius: 4px;
  overflow-y: scroll;
  width: 556px;
  padding: 20px;
  height: 350px;
`;

export const TermsOfServiceAcceptArea = styled.div`
  width: 556px;
`;

export const TermsOfServiceCheckboxContent = styled.div`
  border-radius: 8px;
  align-items: center;
  display: flex;
  margin-top: 15px;
  width: 100%;
`;

export const TermsOfServiceCheckbox = styled.div`
  width: 25px;
  height: 25px;
  border-radius: 4px;
  border: 1.5px solid ${colors.textHyperlink};  
  background: ${prop => prop.checked ? colors.textHyperlink : colors.white};
  margin-right: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
`;

export const TermsOfServiceCheckboxLabel = styled.h6`
  color: ${colors.textPrimary};
  font-size: 16px;
  line-height: 23px;
  font-weight: normal;
`;

export const TermsOfServiceButton = styled.button`
  width: 324px;
  background: ${colors.bgPrimary};
  border: 1px solid ${colors.grayLight};
  border-radius: 46px;
  font-weight: 600;
  font-size: 17px;
  line-height: 21px;
  color: ${colors.white};
  padding: 16px 0;
  margin-top: 35px;
  transition: .2s;

  &:hover {
    background: ${colors.bgPrimaryHover};
    border: 1px solid ${colors.bgPrimaryLight};
  }
`;

export const TermsOfServiceCopyright = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 40px;
`;

export const TermsOfServiceCopyrightTextLine = styled.span`
  display: block;
  font-size: 12px;
  font-weight: 400;
  color: ${colors.textPrimary};
  margin-top: 10px;
`;

export const TermsOfServiceCopyrightImage = styled.img`
  margin-bottom: 5px;
`;

export const ProspectingSubtitleParagraph = styled.p`
  font-size: 14px;
  font-weight: bold;
  color:${colors.textPrimary};
  margin-bottom: 20px;
  margin-top: 20px;
`;

export const ProspectingParagraph = styled.p`
  font-size: 14px;
  line-height: 23px;
  letter-spacing: 0.03em;
  text-align: justify;
  color:${colors.textPrimary};
  margin-top: 20px;
  margin-bottom: 20px;
`;

export const ProspectingNumericList = styled.ol`
  margin-left: 40px;
`;

export const ProspectingNumericListLine = styled.li`
  padding-left: 20px;
  font-size: 14px;
  line-height: 23px;
  letter-spacing: 0.03em;
  text-align: justify;
`;

export const ProspectingUnderlineParagraph = styled.p`
  font-size: 14px;
  line-height: 23px;
  letter-spacing: 0.03em;
  text-align: justify;
  color: ${colors.textPrimary};
  margin-top: 20px;
  margin-bottom: 20px;
  text-decoration: underline;
  font-weight: normal;
`;

export const ProspectingSubtitleParagraphNormal = styled.span`
  font-weight: normal;
  color: ${colors.textPrimary};
`;

export const ProspectingParagraphLink = styled.span`
  color: ${colors.textHyperlink};
`;
